import { render, staticRenderFns } from "./AddGlobalTagModal.vue?vue&type=template&id=321b69f2&lang=pug&"
import script from "./AddGlobalTagModal.vue?vue&type=script&lang=js&"
export * from "./AddGlobalTagModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports